export const STATUS_META = {
  new: { label: "New", cls: "bg-amber-100 text-amber-800" },
  seen: { label: "Seen", cls: "bg-slate-100 text-slate-700" },
  shortlisted: { label: "Shortlisted", cls: "bg-blue-100 text-blue-800" },
  lined_up: { label: "Lined Up", cls: "bg-orange-100 text-orange-800" },
  hired: { label: "Hired", cls: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "Rejected", cls: "bg-rose-100 text-rose-800" },
};

export const STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "seen", label: "Seen" },
  { value: "shortlisted", label: "Shortlisted" },
  { value: "lined_up", label: "Lined Up" },
  { value: "hired", label: "Hired" },
  { value: "rejected", label: "Rejected" },
];

export const GENDER_OPTIONS = ["Male", "Female", "Other"];

export const ENGLISH_LEVELS = [
  { value: "Basic", label: "Basic — understands simple words" },
  { value: "Conversational", label: "Conversational — daily-talk comfortable" },
  { value: "Good", label: "Good — clear & professional with minor mistakes" },
  { value: "Fluent", label: "Fluent — near-native, fully professional" },
];

export const ENGLISH_LEVEL_CHIP = {
  Basic: "bg-rose-50 text-rose-700",
  Conversational: "bg-amber-50 text-amber-800",
  Good: "bg-blue-50 text-blue-800",
  Fluent: "bg-emerald-50 text-emerald-800",
};
